export const FEATURE_FLAG_COOKIE = 'feature-flag-cookie'
